__webpack_require__.p = "/ssamantle-web-client-demo/";